const initState = {
	transferData: {},
	chequeData: {},
}

const transferDataReducer = function (state = initState, action) {
	switch (action.type) {
		case "SET_TRANSFER_DATA":
			return { ...state, 'transferData': action.payload };
		case "SET_CHEQUE_DATA":
			return { ...state, 'chequeData': action.payload };
		default:
			return state;
	}
};

export default transferDataReducer